import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./theme";
import { Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard/Dashboard";
import MainAppBarDark from "./common/MainAppBarDark";
import EventPage from "./pages/Events/EventPage";
import ProjectApp from "./pages/Project/ProjectApp";
import Training from "./pages/Training/Presentation";
import { fetchUserAttributes } from "aws-amplify/auth";
import PressureConverter from "./pages/Converter/PressureConverter";
import MainAppBarExcelsior from "./common/MainAppBarExcelsior";
import HomePage from "./pages/HomePage/HomePage2";
import Qms from "./pages/Qms/Qms";
import Login from "./pages/SignIn/LogIn";
import Audits from "./pages/Audits/Audits";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import TrainingCatalog from "./pages/Training/TrainingCatalog";
import Iso17025SlideDeck from "./pages/Training/Iso17025SlideDeck";

import { Amplify } from "aws-amplify";
import amplifyconfig from "./aws-exports";
Amplify.configure(amplifyconfig);

export default function App() {
  const [userAuth, setUserAuth] = useState("");

  useEffect(() => {
    async function fetchUser() {
      try {
        const currentUser = await fetchUserAttributes();
        setUserAuth(currentUser);
      } catch (err) {
        console.log(err.message);
      }
    }
    fetchUser();
  }, []);

  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes errorElement={<ErrorPage />}>
          <Route path="/" element={<HomePage />} errorElement={<ErrorPage />} />
          <Route
            path="/"
            exact
            element={<MainAppBarExcelsior userAuth />}
            errorElement={<ErrorPage />}
          >
            {/* <Route path="/" element={<HomePage />} errorElement={<ErrorPage />} /> */}
            <Route
              path="conversor"
              element={<PressureConverter />}
              errorElement={<ErrorPage />}
            />
          </Route>

          <Route
            path="/app"
            exact
            element={<MainAppBarDark />}
            errorElement={<ErrorPage />}
          >
            <Route
              path="login"
              element={<Login />}
              errorElement={<ErrorPage />}
            />

            <Route
              path="/app"
              element={<HomePage />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="dashboard"
              name="Visão Geral"
              element={<Dashboard />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="lms"
              element={<Training />}
              errorElement={<ErrorPage />}
            />
            <Route path="treinamentos" element={<TrainingCatalog />} />
            <Route
              path="apresentacao/iso-17025"
              element={<Iso17025SlideDeck />}
            />
            <Route path="qms" element={<Qms />} errorElement={<ErrorPage />} />
            <Route
              path="auditorias"
              element={<Audits />}
              errorElement={<ErrorPage />}
            />
            <Route
              path="eventos"
              element={<EventPage />}
              errorElement={<ErrorPage />}
            />
          </Route>

          <Route
            path="/*"
            element={<ErrorPage />}
            errorElement={<ErrorPage />}
          />
        </Routes>
      </ThemeProvider>
    </React.StrictMode>
  );
}
